import React, { Component } from 'react';
import { Modal, Input, Button, Icon } from 'antd';

export default class TwoFactorModal extends Component {
    state = {
        code: '',
    };

    handleCodeChange = (e) => {
        this.setState({ code: e.target.value });
    };

    handleVerify = () => {
        this.props.onVerify(this.state.code);
        this.setState({ code: '' });
    };

    handleCancel = () => {
        this.setState({ code: '' });
        this.props.onCancel();
    };

    render() {
        const { visible, onResend } = this.props;
        const { code } = this.state;

        return (
            <Modal
                visible={visible}
                title="Two Factor Authentication"
                footer={null}
                onCancel={this.handleCancel}
            >
                <p>
                    An email has been sent to the inserted email address, which contains a Two Factor
                    Authentication code.
                </p>
                <p>Please paste the code in the field below.</p>
                <Input
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.45)' }} />}
                    placeholder="Two Factor Code"
                    value={code}
                    onChange={this.handleCodeChange}
                    onPressEnter={this.handleVerify}
                />
                <p style={{ marginTop: 16 }}>
                    If you haven't received the email, please press{' '}
                    <a onClick={onResend}>here to resend</a>.
                </p>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 24 }}>
                    <Button onClick={this.handleCancel}>Cancel</Button>
                    <Button type="primary" onClick={this.handleVerify}>
                        Verify
                    </Button>
                </div>
            </Modal>
        );
    }
}
